import InviteSeedUser from './InviteSeedUser'

export default InviteSeedUser
